import { Product } from "nvs-types/dist/types/generated/contentful";
import { useMemo } from "react";

export const useHasRedemption = (
  productData: Product | undefined,
  tokenMetadata: any,
) => {
  return useMemo(() => {
    const redemption =
      productData?.tabs?.utilityTab?.badgesCollection?.items[4]?.timeline
        ?.redemption &&
      productData?.tabs?.utilityTab?.badgesCollection?.items[4]?.timeline
        ?.redemption;

    let hasRedemption = false;

    if (
      tokenMetadata &&
      !!redemption &&
      !!redemption.headline &&
      !!redemption.subhead &&
      !!redemption.body &&
      !!redemption.legalRedemptionLink
    ) {
      hasRedemption = true;
    } else {
      hasRedemption = false;
    }

    return { hasRedemption, redemption };
  }, [productData]);
};
